import { chunk } from 'lodash';

import { AssociatedContent } from 'proto/generated/inspector_gadget';

export const getThankYouPagePathName = (sourceUrl: string) => {
  const parsedUrl = new URL(sourceUrl, window.location.origin);

  parsedUrl.pathname += parsedUrl.pathname.endsWith('/') ? 'thank-you' : '/thank-you';

  return parsedUrl.pathname;
};

export const paginate = <T>(array: T[], pageSize: number, currentPage: number) => {
  const paginatedArray = chunk(array, pageSize);
  const pageContent = paginatedArray[currentPage - 1] || [];

  return {
    pageContent,
    totalPages: paginatedArray.length,
  };
};

export const formatAssociatedContentIntoEntity = (associatedContent: AssociatedContent[]) => {
  return associatedContent.map(({ id = '', value }) => ({
    entityId: id.split('&')[0],
    assetId: value,
  }));
};
